import {
  axiosInstanceV1_1,
  axiosInstance,
} from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getReservations = createAsyncThunk(
  "reservations/getReservations",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, searchQuery, eventId, status, orderBy } =
      args;
    const response = await axiosInstanceV1_1.request({
      url: `/events/${eventId}/reservations`,
      method: "get",
      params: { pageSize, pageNumber, searchQuery, status, orderBy },
    });
    return { data: response };
  }
);

export const getReservationById = createAsyncThunk(
  "reservations/getReservationById",
  async (args, thunkAPI) => {
    const { eventId, reservationId } = args;
    const response = await axiosInstanceV1_1.request({
      url: `/events/${eventId}/reservations/${reservationId}`,
      method: "get",
    });
    return { data: response };
  }
);

export const updateReservation = createAsyncThunk(
  "reservations/updateReservation",
  async (args, thunkAPI) => {
    const { eventId, reservationId, data } = args;
    const response = await axiosInstanceV1_1.request({
      url: `/events/${eventId}/reservations/${reservationId}`,
      method: "patch",
      data: data,
    });
    return { data: response };
  }
);

export const getSubscriptionsById = createAsyncThunk(
  "reservations/getSubcriptionsById",
  async (args, thunkAPI) => {
    const { eventId, subscriptionId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/subscriptions/${subscriptionId}`,
      method: "get",
    });
    return { data: response };
  }
);

export const deleteReservations = createAsyncThunk(
  "reservations/deleteReservations",
  async (args, thunkAPI) => {
    const { eventId, reservationId } = args;
    const response = await axiosInstanceV1_1.request({
      url: `/events/${eventId}/reservations/${reservationId}`,
      method: "delete",
    });
    return { data: response };
  }
);

export const deleteRev = async (reservationId, eventId) => {
  await axiosInstanceV1_1.delete(
    `/events/${eventId}/reservations/${reservationId}`,
    ""
  );
};

export const getSeat = createAsyncThunk(
  "reservations/getSeat",
  async (args, thunkAPI) => {
    const { eventId, seatId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/seats/${seatId}`,
      method: "get",
    });
    return { data: response };
  }
);

export const reservationsSlice = createSlice({
  name: "reservations",
  initialState: {
    pendingById: false,
    reservations: [],
    subscription: [],
    pending: false,
    inputSearch: "",
    reservation: [],
    totalRows: 0,
    headers: [],
    seat: {},
    updatePending: false,
    pendingDelete: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setHeaders: (state, action) => {
      state.headers = action.payload;
    },
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
    clearReservation: (state, action) => {
      state.reservation = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReservations.fulfilled, (state, action) => {
        const { data } = action.payload.data;
        state.totalRows = JSON.parse(
          action?.payload.data?.headers["x-pagination"]
        )?.totalCount;
        state.reservations = data;
        state.pending = false;
      })
      .addCase(getReservations.pending, (state, action) => {
        state.pending = true;
      })
      .addCase(getReservations.rejected, (state, action) => {
        state.pending = false;
      })
      .addCase(getReservationById.fulfilled, (state, action) => {
        const { data } = action.payload.data;
        state.reservation = data;
        state.pendingById = false;
      })
      .addCase(getReservationById.pending, (state, action) => {
        state.pendingById = true;
      })
      .addCase(getReservationById.rejected, (state, action) => {
        state.pendingById = false;
      })
      .addCase(getSeat.fulfilled, (state, action) => {
        const { data } = action.payload.data;
        state.seat = data;
        // state.pending = false;
      })
      .addCase(getSeat.pending, (state, action) => {
        // state.pending = true;
      })
      .addCase(getSeat.rejected, (state, action) => {
        // state.pending = false;
      })
      .addCase(getSubscriptionsById.fulfilled, (state, action) => {
        const { data } = action.payload.data;
        state.subscription = data;
        // state.pending = false;
      })
      .addCase(getSubscriptionsById.pending, (state, action) => {
        // state.pending = true;
      })
      .addCase(getSubscriptionsById.rejected, (state, action) => {
        // state.pending = false;
      })
      .addCase(updateReservation.fulfilled, (state, action) => {
        state.updatePending = false;
      })
      .addCase(updateReservation.pending, (state, action) => {
        state.updatePending = true;
      })
      .addCase(updateReservation.rejected, (state, action) => {
        state.updatePending = false;
      })
      .addCase(deleteReservations.fulfilled, (state, action) => {
        state.pendingDelete = false;
      })
      .addCase(deleteReservations.pending, (state, action) => {
        state.pendingDelete = true;
      })
      .addCase(deleteReservations.rejected, (state, action) => {
        state.pendingDelete = false;
      });
  },
});

export const { setInputSearch, clearReservation } = reservationsSlice.actions;

export default reservationsSlice.reducer;
